import { render, staticRenderFns } from "./PlatformNotificationsListItem.vue?vue&type=template&id=16a10c24&"
import script from "./PlatformNotificationsListItem.vue?vue&type=script&lang=js&"
export * from "./PlatformNotificationsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports